// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/Popover.js with go/sail-next-tailor-docs-publisher 

import React, { useRef, useState } from 'react';
import { Button, Popover } from '@sail/ui';
import * as Theme from '@sail/theme';
import { deprecatedCss, view } from '@sail/engine';

const PopoverExample = () => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  return <>
      <Button ref={ref} onPress={() => setOpen(!open)}>
        Toggle popover
      </Button>
      {open && <Popover placement="bottom" targetRef={ref} onClose={() => setOpen(false)}>
          <view.div uses={[Theme.caption, deprecatedCss`
                border-radius: $radius-default;
                background: $color-background-container;
                margin: $spacing-sm;
                padding: $spacing-md;
                color: $color-text-secondary;
                width: 150px;
                height: 100px;
                layout: column;
                align-y: center;
                align-x: center;
              `]}>
            Popover contents
          </view.div>
        </Popover>}
    </>;
};

const basic = {
  rendered: <PopoverExample />,
  source: `const ref = useRef(null);
const [open, setOpen] = useState(false);

return (
  <>
    <Button ref={ref} onPress={() => setOpen(!open)}>
      Toggle popover
    </Button>

    {open && (
      <Popover
        placement="bottom"
        targetRef={ref}
        onClose={() => setOpen(false)}
      >
        Popover contents
      </Popover>
    )}
  </>
);`
};
export const PopoverExamples = {
  basic
};